<template>
  <div class="info-block">
    <div class="container-info">
      <h2 class="info-block__title" v-html="slide.title"></h2>
      <div class="info-block__description" v-html="slide.description"></div>
      <DescriptionTable class="info-block__table" v-if="slide.stats.length > 0" :stats="slide.stats"></DescriptionTable>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Button from "./common/Button"
import DescriptionTable from "./common/DescriptionTable"

export default {
  name:"InfoBlock",
  components: {
    DescriptionTable,
    Button
  },
  data: () => ({

  }),
  props: {
    slide: Object
  },
  computed: {
    isMobile() {
      return window.innerWidth < 1000
    }
  }
}
</script>


<style lang="stylus" scoped>
  @import '../styles/tools'
  .info-block
    font-family GraphikLCG
    color white
    box-sizing border-box

    &__title
      font-size 26px
      line-height 1.01
      color white
      font-weight normal
      margin-bottom 18px
      @media (min-width: 600px) and (max-width: 768px)
        width-between-property 'font-size' 600 26 768 50 true true
        width-between-property 'margin-bottom' 600 18 768 50 true true
      @media (min-width: 768px)
        font-size 50px
        margin-bottom 50px

    &__description
      font-size 13px
      line-height 1.4
      @media (min-width: 600px) and (max-width: 768px)
        width-between-property 'font-size' 600 13 768 17 true true
      @media (min-width: 768px)
        font-size 17px

    &__table
      margin-top 30px


.container-info
    max-width 100%
    @media (min-width 1000px)
      max-width 450px
.bordered
  border-radius 32px
  border solid 3px $white

</style>